import type { Entitlement } from "@pages/ProductCatalog/store";
import type { TableSort } from "@pages/v2/components/ui/table/SortTable";

import type { Transaction } from "../transactions/types";

interface WhereEmail {
  email?: {
    contains: string;
  };
}

interface WhereCreatedAt {
  createdAt?: {
    gte: string;
    lte: string;
  };
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  ARCHIVED = "ARCHIVED",
}

export interface User {
  id: string;
  email: string;
  status: UserStatus;
  createdAt: string;
  entitlements?: Entitlement[];
  transactions?: Transaction[];
}

export interface GetUserQueryResponse {
  getUser: User;
}

export interface ListUsersQueryResponse {
  listUsers: User[];
  countUsers: number;
}

export interface CreateUserMutationResponse {
  createUser: User;
}

export interface UpdateUserMutationResponse {
  updateUser: User;
}

export interface DeleteUserMutationResponse {
  deleteUser: { id: string };
}

export interface SearchUsersQueryVariables {
  take?: number;
  skip?: number;
  where: WhereEmail &
    WhereCreatedAt & {
      OR?: WhereEmail | WhereCreatedAt;
    };
  orderBy?: { [Key in keyof User]?: TableSort }[];
}
